<template>
  <div ref="ex">
    <div class="correct">
      <div class="font-bold text-center text-3xl pb-10">Correct Examples</div>
      <div
        class="examplesPage w-8/12 text-center rounded-3xl"
        style="margin: 0px auto; height: 700px"
      >
        <div class="carousel-container">
          <div
            class="carousel-slide"
            v-for="(image, index) in correctImages"
            :key="index"
            v-show="index === activeIndex"
          >
            <img
              class="w-full h-full object-contain"
              :src="image"
              :alt="'Image ' + index"
            />
          </div>
          <div
            class="cursor-pointer absolute bottom-1/2 -left-32 rounded-full w-11 h-11 shadow-md flex justify-center items-center hover:scale-125 transition-all"
            @click="prev"
          >
            <img src="resources/img/figures/left.png" class="scale-50" alt="" />
          </div>
          <div
            class="w-5/6 h-8 flex justify-center items-center absolute bottom-6"
          >
            <div
              v-for="(item, index) in correctImages"
              :key="item"
              class="rounded-full w-3 h-3 shadow-md shadow-black ml-1 cursor-pointer hover:scale-110 transition-all"
              @click="changeExamples(index)"
            ></div>
          </div>

          <div
            class="cursor-pointer absolute bottom-1/2 -right-32 rounded-full w-11 h-11 shadow-md flex justify-center items-center hover:scale-125 transition-all"
            @click="next"
          >
            <img
              src="resources/img/figures/right.png"
              class="scale-50"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="error">
      <div class="font-bold text-center text-3xl pb-10 pt-20">
        Error Examples
      </div>
      <div
        class="examplesPage w-8/12 text-center rounded-3xl"
        style="margin: 0px auto; height: 700px"
      >
        <div class="carousel-container">
          <div
            class="carousel-slide"
            v-for="(image, index) in errImages"
            :key="index"
            v-show="index === activeErrIndex"
          >
            <img
              class="w-full h-full object-contain"
              :src="image"
              :alt="'Image ' + index"
            />
          </div>
          <div
            class="cursor-pointer absolute bottom-1/2 -left-32 rounded-full w-11 h-11 shadow-md flex justify-center items-center hover:scale-125 transition-all"
            @click="prevErr"
          >
            <img src="resources/img/figures/left.png" class="scale-50" alt="" />
          </div>
          <div
            class="w-5/6 h-8 flex justify-center items-center absolute bottom-6"
          >
            <div
              v-for="(item, index) in errImages"
              :key="item"
              class="rounded-full w-3 h-3 shadow-md shadow-black ml-1 cursor-pointer hover:scale-110 transition-all"
              @click="changeErrExam(index)"
            ></div>
          </div>

          <div
            class="cursor-pointer absolute bottom-1/2 -right-32 rounded-full w-11 h-11 shadow-md flex justify-center items-center hover:scale-125 transition-all"
            @click="nextErr"
          >
            <img
              src="resources/img/figures/right.png"
              class="scale-50"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="invalid">
      <div class="font-bold text-center text-3xl pb-10 pt-20">
        Invalid Examples
      </div>
      <div
        class="examplesPage w-8/12 text-center rounded-3xl"
        style="margin: 0px auto; height: 700px"
      >
        <div class="carousel-container">
          <div
            class="carousel-slide"
            v-for="(image, index) in invalidImages"
            :key="index"
            v-show="index === activeInvalidIndex"
          >
            <img
              class="w-full h-full object-contain"
              :src="image"
              :alt="'Image ' + index"
            />
          </div>
          <div
            class="cursor-pointer absolute bottom-1/2 -left-32 rounded-full w-11 h-11 shadow-md flex justify-center items-center hover:scale-125 transition-all"
            @click="prevInvalid"
          >
            <img src="resources/img/figures/left.png" class="scale-50" alt="" />
          </div>
          <div
            class="w-5/6 h-8 flex justify-center items-center absolute bottom-6"
          >
            <div
              v-for="(item, index) in invalidImages"
              :key="item"
              class="rounded-full w-3 h-3 shadow-md shadow-black ml-1 cursor-pointer hover:scale-110 transition-all"
              @click="changeInvExam(index)"
            ></div>
          </div>

          <div
            class="cursor-pointer absolute bottom-1/2 -right-32 rounded-full w-11 h-11 shadow-md flex justify-center items-center hover:scale-125 transition-all"
            @click="nextInvalid"
          >
            <img
              src="resources/img/figures/right.png"
              class="scale-50"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="refine">
      <div class="font-bold text-center text-3xl pb-10 pt-20">
        Refine Examples
      </div>
      <div
        class="examplesPage w-8/12 text-center rounded-3xl"
        style="margin: 0px auto; height: 700px"
      >
        <div class="carousel-container">
          <div
            class="carousel-slide"
            v-for="(image, index) in refineImages"
            :key="index"
            v-show="index === activeRefineIndex"
          >
            <img
              class="w-full h-full object-contain"
              :src="image"
              :alt="'Image ' + index"
            />
          </div>
          <div
            class="cursor-pointer absolute bottom-1/2 -left-32 rounded-full w-11 h-11 shadow-md flex justify-center items-center hover:scale-125 transition-all"
            @click="prevRefine"
          >
            <img src="resources/img/figures/left.png" class="scale-50" alt="" />
          </div>
          <div
            class="w-5/6 h-8 flex justify-center items-center absolute bottom-6"
          >
            <div
              v-for="(item, index) in refineImages"
              :key="item"
              class="rounded-full w-3 h-3 shadow-md shadow-black ml-1 cursor-pointer hover:scale-110 transition-all"
              @click="changeRefExam(index)"
            ></div>
          </div>

          <div
            class="cursor-pointer absolute bottom-1/2 -right-32 rounded-full w-11 h-11 shadow-md flex justify-center items-center hover:scale-125 transition-all"
            @click="nextRefine"
          >
            <img
              src="resources/img/figures/right.png"
              class="scale-50"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      refineImages: [
        "./resources/img/case_refine/refine_case_2.jpg",
        // 添加更多图片路径
      ],
      invalidImages: [
        "./resources/img/case_invalid/1.jpg",
        "./resources/img/case_invalid/2.jpg",
        "./resources/img/case_invalid/3.jpg",
        "./resources/img/case_invalid/4.jpg",
        "./resources/img/case_invalid/5.jpg",
        "./resources/img/case_invalid/6.jpg",
        "./resources/img/case_invalid/7.jpg",
        "./resources/img/case_invalid/8.jpg",
        "./resources/img/case_invalid/9.jpg",
        "./resources/img/case_invalid/10.jpg",
        "./resources/img/case_invalid/11.jpg",
        "./resources/img/case_invalid/12.jpg",
        "./resources/img/case_invalid/13.jpg",
        "./resources/img/case_invalid/14.jpg",
        "./resources/img/case_invalid/15.jpg",
        // 添加更多图片路径
      ],
      errImages: [
        "./resources/img/case_error/error_case_1.jpg",
        "./resources/img/case_error/error_case_2.jpg",
        "./resources/img/case_error/error_case_3.jpg",
        "./resources/img/case_error/error_case_4.jpg",
        "./resources/img/case_error/error_case_5.jpg",
        "./resources/img/case_error/error_case_6.jpg",
        "./resources/img/case_error/error_case_7.jpg",
        "./resources/img/case_error/error_case_8.jpg",
        "./resources/img/case_error/error_case_9.jpg",
        "./resources/img/case_error/error_case_10.jpg",
        "./resources/img/case_error/error_case_11.jpg",
        "./resources/img/case_error/error_case_12.jpg",
        "./resources/img/case_error/error_case_13.jpg",
        "./resources/img/case_error/error_case_14.jpg",
        "./resources/img/case_error/error_case_15.jpg",
        "./resources/img/case_error/error_case_16.jpg",
        "./resources/img/case_error/error_case_17.jpg",
        "./resources/img/case_error/error_case_18.jpg",
        "./resources/img/case_error/error_case_19.jpg",
        "./resources/img/case_error/error_case_20.jpg",
        "./resources/img/case_error/error_case_21.jpg",
        "./resources/img/case_error/error_case_22.jpg",
        "./resources/img/case_error/error_case_23.jpg",
        "./resources/img/case_error/error_case_24.jpg",
        "./resources/img/case_error/error_case_25.jpg",
        "./resources/img/case_error/error_case_26.jpg",
        "./resources/img/case_error/error_case_27.jpg",
        "./resources/img/case_error/error_case_28.jpg",
        "./resources/img/case_error/error_case_29.jpg",
        "./resources/img/case_error/error_case_30.jpg",
        // 添加更多图片路径
      ],
      correctImages: [
        "./resources/img/case_correct/correct_case_1.jpg",
        "./resources/img/case_correct/correct_case_2.jpg",
        "./resources/img/case_correct/correct_case_3.jpg",
        "./resources/img/case_correct/correct_case_4.jpg",
        "./resources/img/case_correct/correct_case_5.jpg",
        "./resources/img/case_correct/correct_case_6.jpg",
        "./resources/img/case_correct/correct_case_7.jpg",
        "./resources/img/case_correct/correct_case_8.jpg",
        "./resources/img/case_correct/correct_case_9.jpg",
        "./resources/img/case_correct/correct_case_10.jpg",
        "./resources/img/case_correct/correct_case_11.jpg",
        "./resources/img/case_correct/correct_case_12.jpg",
        "./resources/img/case_correct/correct_case_13.jpg",
        "./resources/img/case_correct/correct_case_14.jpg",
        "./resources/img/case_correct/correct_case_15.jpg",
        "./resources/img/case_correct/correct_case_16.jpg",
        "./resources/img/case_correct/correct_case_17.jpg",
        "./resources/img/case_correct/correct_case_18.jpg",
        "./resources/img/case_correct/correct_case_19.jpg",
        "./resources/img/case_correct/correct_case_20.jpg",
        "./resources/img/case_correct/correct_case_21.jpg",
        "./resources/img/case_correct/correct_case_22.jpg",
        "./resources/img/case_correct/correct_case_23.jpg",
        "./resources/img/case_correct/correct_case_24.jpg",
        "./resources/img/case_correct/correct_case_25.jpg",
        "./resources/img/case_correct/correct_case_26.jpg",
        "./resources/img/case_correct/correct_case_27.jpg",
        "./resources/img/case_correct/correct_case_28.jpg",
        "./resources/img/case_correct/correct_case_29.jpg",
        "./resources/img/case_correct/correct_case_30.jpg",
        // 添加更多图片路径
      ],
      activeIndex: 0, // 当前显示的图片索引
      activeErrIndex: 0,
      activeInvalidIndex: 0,
      activeRefineIndex: 0,
    };
  },
  methods: {
    // correct
    next() {
      this.activeIndex++;
      if (this.activeIndex >= this.correctImages.length) {
        this.activeIndex = 0;
      }
    },
    prev() {
      this.activeIndex--;
      if (this.activeIndex < 0) {
        this.activeIndex = this.correctImages.length - 1;
      }
    },
    // error
    nextErr() {
      this.activeErrIndex++;
      if (this.activeErrIndex >= this.errImages.length) {
        this.activeErrIndex = 0;
      }
    },
    prevErr() {
      this.activeErrIndex--;
      if (this.activeErrIndex < 0) {
        this.activeErrIndex = this.errImages.length - 1;
      }
    },
    // invalid
    nextInvalid() {
      this.activeInvalidIndex++;
      if (this.activeInvalidIndex >= this.invalidImages.length) {
        this.activeInvalidIndex = 0;
      }
    },
    prevInvalid() {
      this.activeInvalidIndex--;
      if (this.activeInvalidIndex < 0) {
        this.activeInvalidIndex = this.invalidImages.length - 1;
      }
    },
    // refine
    nextRefine() {
      this.activeRefineIndex++;
      if (this.activeRefineIndex >= this.refineImages.length) {
        this.activeRefineIndex = 0;
      }
    },
    prevRefine() {
      this.activeRefineIndex--;
      if (this.activeRefineIndex < 0) {
        this.activeRefineIndex = this.refineImages.length - 1;
      }
    },
    // 切换图片correct
    changeExamples(idx) {
      this.activeIndex = idx;
    },
    // 切换图片error
    changeErrExam(idx) {
      this.activeErrIndex = idx;
    },
    // 切换图片invalid
    changeInvExam(idx) {
      this.activeInvalidIndex = idx;
    },
    // 切换图片refine
    changeRefExam(idx) {
      this.activeRefineIndex = idx;
    },
  },
};
</script>

<style scoped>
.examplesPage {
  box-shadow: 3px 3px 3px 3px rgb(213, 211, 211);
}
.carousel-container {
  position: relative;
  width: 70%;
  height: 700px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.carousel-slide {
  position: absolute;
  transition: 0.5s ease;
  width: 100%;
  height: 100%;
}
</style>
